var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 37,
    viewBox: "0 0 174 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.838 18.3034C13.6397 18.3034 15.9069 19.1328 17.6395 20.7917C19.409 22.4506 20.2937 24.5518 20.2937 27.0955C20.2937 29.5285 19.4274 31.6666 17.6948 33.5098C15.9622 35.3162 13.8609 36.2193 11.391 36.2193H0V28.9755L10.6169 29.0308C11.0961 29.0308 11.5016 28.8465 11.8334 28.4779C12.1652 28.0724 12.331 27.6116 12.331 27.0955C12.331 26.0633 11.6306 25.5472 10.2298 25.5472C7.39125 25.5472 5.03195 24.6071 3.15188 22.7271C1.30868 20.847 0.387073 18.5799 0.387073 15.9256C0.387073 13.6032 1.32711 11.5757 3.20718 9.84306C5.08725 8.11045 7.2438 7.24414 9.67683 7.24414H27.5928L20.0172 14.8197L9.40035 14.7644C8.95798 14.7644 8.55247 14.8934 8.18383 15.1515C7.85206 15.3727 7.68617 15.7229 7.68617 16.2021C7.68617 17.0131 7.96265 17.5661 8.51561 17.861C9.21603 18.1559 9.99017 18.3034 10.838 18.3034Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9895 14.7091L37.9522 7.24414V36.2193H29.9895V14.7091ZM22.6904 14.7644L30.2107 7.24414H48.0161L40.4958 14.7644H22.6904Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7439 24.4409L67.1848 0H75.811V36.219H65.8577V31.5741H50.1536L59.0563 22.7267H65.8577V13.1052L42.7439 36.219V24.4409Z",
    fill: "url(#paint0_linear_36_288)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1667 9.95331L88.12 0V36.219H78.1667V9.95331ZM97.7415 0C101.428 0 104.359 0.958467 106.534 2.8754C108.709 4.75547 109.796 7.59401 109.796 11.391C109.796 14.6351 108.709 17.3446 106.534 19.5196C104.396 21.6577 101.557 22.7267 98.018 22.7267C96.4697 22.7267 95.6956 22.5793 95.6956 22.2844L95.9168 22.0632L96.525 21.7867L90.6083 17.2524L95.0873 17.1971C96.5619 17.1971 97.6862 16.81 98.4604 16.0359C99.2345 15.2617 99.6216 14.2848 99.6216 13.1052C99.6216 11.9255 99.2714 11.0039 98.571 10.3404C97.9074 9.67683 96.7462 9.34505 95.0873 9.34505L88.12 9.40035V0H97.7415ZM109.52 36.4955L90.2766 17.2524H102.055L109.52 24.8833V36.4955Z",
    fill: "url(#paint1_linear_36_288)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.172 9.28976L131.125 0V36.219H121.172V9.28976ZM112.048 9.40035L121.448 0H143.733L134.332 9.40035H112.048Z",
    fill: "url(#paint2_linear_36_288)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.411 26.819L156.93 7.24414H163.787V36.2193H155.824V32.5145H143.272L150.405 25.4366H155.824V17.7504L137.411 36.2193V26.819Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.037 15.2068L174 7.24414V36.2193H166.037V15.2068Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_288",
    x1: 143.77,
    y1: 36.4955,
    x2: 42.8545,
    y2: 0.0000162002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A95EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_288",
    x1: 143.77,
    y1: 36.4955,
    x2: 42.8545,
    y2: 0.0000162002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A95EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36_288",
    x1: 143.77,
    y1: 36.4955,
    x2: 42.8545,
    y2: 0.0000162002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A95EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/LogoIcon.7c1521d08903f182dc7eb8296943fe43.svg";
export { ForwardRef as ReactComponent };